import { render } from "./ReportPage.vue?vue&type=template&id=1f1c51f8&scoped=true&ts=true"
import script from "./ReportPage.vue?vue&type=script&lang=ts"
export * from "./ReportPage.vue?vue&type=script&lang=ts"

import "./ReportPage.vue?vue&type=style&index=0&id=1f1c51f8&lang=scss&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1c51f8"]])

export default __exports__